import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { provideHttpClient } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr'; // ✅ standalone way for Toastr
import { importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // Required for Toastr animations

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    provideHttpClient(),          // ✅ HTTP support
    provideToastr(),              // ✅ Toastr support
    importProvidersFrom(BrowserAnimationsModule) // ✅ required by Toastr
  ]
}).catch(err => console.error(err));
